module.exports = __webpack_public_path__ + "assets/webfonts/fa-solid-900.ttf";